import React, { useMemo } from 'react';
import MySizesFilterSection from '@components/catalog/my-sizes/mysizes-filter-section/mysizes-filter-section';
import { useContextSelector } from 'use-context-selector';
import { UserContext } from '@context/user.context';
import { CatalogContext } from '@context/catalog.context';
import useAnalyticEvents from '@hooks/analytics/use-analytic-events';
import useUser from '@hooks/user/use-user';

const MysizesWrapper: React.FC = () => {
  const userSizes = useContextSelector(UserContext, (v) => v.userSizes);
  const areMySizesApplicable = useContextSelector(CatalogContext, (v) => v.areMySizesApplicable);
  const { isAuthenticated } = useUser();
  const areMySizesEnabled = useContextSelector(CatalogContext, (v) => v.areMySizesEnabled);
  const setMySizesState = useContextSelector(CatalogContext, (v) => v.setMySizesState);
  const isManualSwitchRef = useContextSelector(CatalogContext, (v) => v.isManualSwitchRef);
  const setMySizesDialogOpen = useContextSelector(CatalogContext, (v) => v.setMySizesDialogOpen);

  const { sendAnalyticEvent } = useAnalyticEvents('my_preferences');

  const doesUserHaveSizes = useMemo<boolean>(() => {
    return userSizes?.universe?.ids.length > 0;
  }, [userSizes]);

  const handleSwitchChange = (): void => {
    isManualSwitchRef.current = true;
    setMySizesState((prev) => ({ ...prev, enabled: !prev.enabled }), true);
    sendAnalyticEvent('preferences_enabled', { eventLabel: areMySizesEnabled ? 'disabled' : 'enabled' });
  };

  const handleOpenConfigurationDialog = () => {
    setMySizesDialogOpen(true);
    sendAnalyticEvent('onboarding_preferences_open');
  };

  const handleOpenEditDialog = () => {
    setMySizesDialogOpen(true);
    sendAnalyticEvent('edit_preferences_open');
  };

  const showNoResult = isAuthenticated && doesUserHaveSizes && !areMySizesApplicable;
  const showAddMySizes = !isAuthenticated || !doesUserHaveSizes;
  const showCurrentMySizes = isAuthenticated && doesUserHaveSizes && areMySizesApplicable;

  return (
    <>
      <MySizesFilterSection
        {...{
          showCurrentMySizes,
          showNoResult,
          showAddMySizes,
          handleSwitchChange,
          handleOpenEditDialog,
          handleOpenConfigurationDialog,
        }}
      />
    </>
  );
};

export default MysizesWrapper;
